// extracted by mini-css-extract-plugin
export default {"btn":"AboutHero_btn__XwU9-","primary":"AboutHero_primary__OI5im"};